import React from 'react'
import './styles.scss'
import Stars from '../stars/stars.component'

export function List(props) {
  return (
    <div className='list'>
      <h3>{props.title}</h3>
      <table cellSpacing={0}>
        <thead>
          <tr>
            <td>Name</td>
            <td>Anzahl</td>
            <td>Bewertung</td>
          </tr>
        </thead>
        <tbody>
          {props.data.map((e, i) => {
            return (
              <tr key={i}>
                <td className='cell'>
                  <a
                    href={`https://www.google.com/maps/place/?q=place_id:${e[1]}`}
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    {e[0]}
                  </a>
                </td>
                <td className='cell'>{e[2]}</td>
                <td className='cell rating'>
                  <span>{e[3]}</span>
                  <Stars rating={e[3]} />
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default List
